// DataTable configuration constants
export const DATA_TABLE_PROPS = {
  DEFAULT: {
    isDark: true,
    selection: 'single',
    showFilterButton: false,
    showColumnFilters: false,
    showFilterToolbar: false,
    showPagination: false,
    manualPagination: false,
    enableSorting: false,
    showGlobalActions: false
  }
};

// Table column configurations
export const TABLE_COLUMNS = {
  PRODUCTS: {
    PRODUCT_ID: {
      columnKey: 'productId',
      header: 'PRODUCT ID'
    },
    PRODUCT_NAME: {
      columnKey: 'productName',
      header: 'PRODUCT NAME'
    },
    DETAILS: {
      columnKey: 'details',
      header: 'DETAILS'
    },
    PRIORITY: {
      columnKey: 'priority',
      header: 'PRIORITY'
    }
  }
};

// CSS classes used across components
export const CSS_CLASSES = {
  COMMON: {
    SECTION_BORDER: 'sc-border grid pl-4',
    GRID_3_COLS: 'grid grid-cols-3 gap-4 pb-6 pl-4',
    FLEX_COL_GAP: 'flex flex-col gap-4',
    TEXT_SMALL: 'text-sm',
    PADDING_TOP: 'pt-3'
  },
  BUTTONS: {
    EDIT: 'ml-8 flex items-center text-sm text-[#0069D7] border-none'
  },
  LAYOUT: {
    CONTAINER: 'reward-review-container mt-4 flex flex-col gap-6',
    SECTION_WRAPPER: 'mt-2 w-full'
  }
};

// Button configurations
export const BUTTON_CONFIG = {
  EDIT: {
    TITLE: 'Edit',
    ICON: 'edit'
  }
};

// Component size configurations
export const ACCORDION_CONFIG = {
  DEFAULT: {
    isDark: true,
    expanded: true,
    size: 'small'
  }
};
